
import {USER, MANAGER, ADMIN} from './role';
import Authorization from './Authorization';

//export const AllEnabled = Authorization([USER, MANAGER, ADMIN]);
export const UserAndManagerEnabled = Authorization([USER, MANAGER]);
export const ManagerEnabled = Authorization([MANAGER]);
export const ManagerAndAdminEnabled = Authorization([MANAGER, ADMIN]);
export const AdminEnabled = Authorization([ADMIN]);